export const MONTH_LABELS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export const PERIOD_OPTIONS = [
  { label: 'Mês atual', value: 'current_month' },
  { label: 'Últimos 30 dias', value: 'last_30_days' },
  { label: 'Últimos 3 meses', value: 'last_3_months' },
  { label: 'Últimos 6 meses', value: 'last_6_months' },
  { label: 'Últimos 12 meses', value: 'last_12_months' },
];
